import { render, staticRenderFns } from "./ImportUserModal.vue?vue&type=template&id=2180cabf&"
import script from "./ImportUserModal.vue?vue&type=script&lang=js&"
export * from "./ImportUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports